import { render, staticRenderFns } from "./PSidebar.vue?vue&type=template&id=300a4fe3&scoped=true"
import script from "./PSidebar.vue?vue&type=script&lang=ts"
export * from "./PSidebar.vue?vue&type=script&lang=ts"
import style0 from "./PSidebar.vue?vue&type=style&index=0&id=300a4fe3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300a4fe3",
  null
  
)

export default component.exports